import {useMemo} from "react";
import {useTranslation} from "react-i18next";

interface IProps<T> {
    array: T[],
    translateKeys?: string[]
}

export function useTranslateArray<T =unknown>({
                                                                         array,
                                                                         translateKeys = ['title']
                                                                     }: IProps<T>): T[] {
    const {t, i18n} = useTranslation()
    return useMemo(() => {
        if (!array?.length) {
            return []
        }
        return array.map((item) => {
            let newItem: { [key: string]: string } = {}
            //@ts-ignore
            translateKeys.forEach((key: keyof T) => {
                const typedKey = key as Extract<keyof T, string>;
                const value = t(item[typedKey] as string);
                newItem[typedKey] = value ?? '';

            })
            return {
                ...item,
                ...newItem
            };
        })
    }, [array, i18n.language])
}

type Array<T> = T[]
type MatrixItem<T> = Array<T>[]

interface IPropsMatrix<T> {
    array: MatrixItem<T>,
    translateKeys?: string[]
}

export function useTranslateMatrix<T=unknown>({
                                                                          array,
                                                                          translateKeys = ['title']
                                                                      }: IPropsMatrix<T>): T[][] {
    const {t, i18n} = useTranslation()
    return useMemo(() => {
        if (!array?.length) {
            return []
        }

        return array.map((item) => {
            return item?.map((it) => {
                let newItem: { [key: string]: string } = {}
                //@ts-ignore
                translateKeys.forEach((key: keyof T) => {
                    const typedKey = key as Extract<keyof T, string>;
                    const value = t(it[typedKey] as string);
                    newItem[typedKey] = value ?? '';

                })
                return {
                    ...it,
                    ...newItem
                };
            })
        })
    }, [array, i18n.language])
}